var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('legend', [_vm._v("Add Damage By Operation")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    key: _vm.key,
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("AWB Number:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "awbnumber",
      "name": "awbnumber",
      "type": "text"
    },
    model: {
      value: (_vm.awbNumber),
      callback: function($$v) {
        _vm.awbNumber = $$v
      },
      expression: "awbNumber"
    }
  }), _vm._v(" "), _c('b-input-group-button', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        return _vm.searchAwbNumber(_vm.awbNumber)
      }
    }
  }, [_vm._v("\n                        Go "), _c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Current Region Name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-university'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "hubzonename",
      "name": "hubzonename",
      "type": "text"
    },
    model: {
      value: (_vm.hubzonename),
      callback: function($$v) {
        _vm.hubzonename = $$v
      },
      expression: "hubzonename"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Origin HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "OriginHub",
      "name": "originHubName",
      "type": "text"
    },
    model: {
      value: (_vm.originHubName),
      callback: function($$v) {
        _vm.originHubName = $$v
      },
      expression: "originHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Current HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Currenthub",
      "name": "currentHubName",
      "type": "text"
    },
    model: {
      value: (_vm.currentHubName),
      callback: function($$v) {
        _vm.currentHubName = $$v
      },
      expression: "currentHubName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Destination HUB/SVC name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-map-marker'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Destinationhub",
      "name": "destinationHubName",
      "type": "text"
    },
    model: {
      value: (_vm.destinationHubName),
      callback: function($$v) {
        _vm.destinationHubName = $$v
      },
      expression: "destinationHubName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Last Service [Coloder/Vender] :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "lastService",
      "name": "lastService",
      "type": "text"
    },
    model: {
      value: (_vm.lastService),
      callback: function($$v) {
        _vm.lastService = $$v
      },
      expression: "lastService"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Bag Condition :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "bagCondition",
      "name": "bagCondition",
      "type": "text"
    },
    model: {
      value: (_vm.bagCondition),
      callback: function($$v) {
        _vm.bagCondition = $$v
      },
      expression: "bagCondition"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" DEPS Bag Condition :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-suitcase'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.vStatusList,
      "selected-option": _vm.DEPSbagcondition,
      "name": "DEPSbagCondition",
      "placeholder": "Select DEPSbag condition"
    },
    on: {
      "select": _vm.selectDEPSbagcondition
    },
    model: {
      value: (_vm.DEPSbagCondition),
      callback: function($$v) {
        _vm.DEPSbagCondition = $$v
      },
      expression: "DEPSbagCondition"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" OctroiMRP :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "OctroiMRP",
      "name": "OctroiMRP",
      "type": "text"
    },
    model: {
      value: (_vm.OctroiMRP),
      callback: function($$v) {
        _vm.OctroiMRP = $$v
      },
      expression: "OctroiMRP"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Client Name :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "Clientname",
      "name": "Clientname",
      "type": "text"
    },
    model: {
      value: (_vm.Clientname),
      callback: function($$v) {
        _vm.Clientname = $$v
      },
      expression: "Clientname"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Product Description :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "productDescription",
      "name": "productDescription",
      "type": "text"
    },
    model: {
      value: (_vm.productDescription),
      callback: function($$v) {
        _vm.productDescription = $$v
      },
      expression: "productDescription"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" STD Reason :")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.StatusList,
      "selected-option": _vm.stdreason,
      "name": "STDreason",
      "placeholder": "Select STD Reason"
    },
    on: {
      "select": _vm.selectstdreason
    },
    model: {
      value: (_vm.STDreason),
      callback: function($$v) {
        _vm.STDreason = $$v
      },
      expression: "STDreason"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload 3 Images",
      "description": "Allowed image file types: gif, jpg, jpeg, png (Maximum Size: 600 KB).",
      "label-cols": "3"
    }
  }), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "description": "Note:If Octroi MRP is greater than 1000 then uploading images is mandatory."
    }
  }), _vm._v(" "), _c('b-input-group', [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_vm._v("Choose Files")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }, [_vm._v("Upload "), _c('i', {
    staticClass: "fa fa-upload"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px black"
    }
  }, [(_vm.imagesarr.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Total Images to be uploded : " + _vm._s(_vm.imagesarr.length) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.imagesarr.length != 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.imagesarr), function(x, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(x.file))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.viewImage(x.preview)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View\n                      ")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "success",
        "href": x.preview,
        "download": ""
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download\n                      ")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                      ")])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description :"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatedata()
      }
    }
  }, [_vm._v(" Save "), _c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_vm._v(" Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "imgPopUp",
      "title": "Image Preview",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('span', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.closeImage()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.imgData,
      "alt": "Preview"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "download-btn"
  }, [_c('a', {
    attrs: {
      "href": _vm.imgData,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n        ")])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a39ba854","hasScoped":false}!./src/views/components/STDdamaged/stddamaged.component.html
// module id = 1583
// module chunks = 1